/**
 * V2 twin of App.js `applyEligibilityResult` (~line 3483) — patches the
 * global client lists after a 270/271 eligibility check so eligibility
 * badges update immediately without a full refetch.
 * Keep the field mapping in sync with the legacy implementation.
 */
export const patchClientEligibility = (client, clientId, { status, copayAmounts, deductible, coinsurance, lastChecked }, insuranceIndex = 0) => {
  if (!client || client.id !== clientId) return client;
  const now = lastChecked || new Date().toISOString();
  if (!insuranceIndex || insuranceIndex === 0) {
    return {
      ...client,
      primary_eligibility_status: status,
      last_eligibility_check: now,
      ...(copayAmounts != null && { eligibility_copay_amounts: copayAmounts }),
      ...(deductible != null && { eligibility_deductible: deductible }),
      ...(coinsurance != null && { eligibility_coinsurance: coinsurance }),
    };
  }
  // Secondary / tertiary: patch the matching insurance entry, matching the
  // backend's active-by-priority ordering (routes/eligibility.py:733-736).
  const insurances = Array.isArray(client.insurances) ? client.insurances : [];
  const activeSorted = insurances
    .map((ins, origIdx) => ({ ins, origIdx }))
    .filter((x) => x.ins?.status === 'active')
    .sort((a, b) => (a.ins.priority || 99) - (b.ins.priority || 99));
  const target = activeSorted[insuranceIndex];
  if (!target) return client;
  const nextInsurances = insurances.map((ins, origIdx) =>
    origIdx === target.origIdx
      ? { ...ins, eligibility_status: status, eligibility_checked_at: now }
      : ins,
  );
  return { ...client, insurances: nextInsurances };
};

export const applyEligibilityPatch = ({ setClients, setAllClientsForLookup, setSelectedClient }, clientId, patch, insuranceIndex = 0) => {
  const run = (prevList) => (prevList || []).map((c) => patchClientEligibility(c, clientId, patch, insuranceIndex));
  setClients?.((prev) => run(prev));
  setAllClientsForLookup?.((prev) => run(prev));
  setSelectedClient?.((prev) => (prev ? patchClientEligibility(prev, clientId, patch, insuranceIndex) : prev));
};
